var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLatestProgrammes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77009 2.78646H6.5558V5.13021L8.39732 6.30208L8.00446 6.97917L5.77009 5.54688V2.78646ZM2.94643 1.45833C3.87946 0.486111 4.99256 0 6.28571 0C7.57887 0 8.68378 0.486111 9.60045 1.45833C10.5335 2.43056 11 3.61111 11 5C11 6.38889 10.5335 7.56944 9.60045 8.54167C8.68378 9.51389 7.57887 10 6.28571 10C5.74554 10 5.14807 9.86111 4.4933 9.58333C3.85491 9.28819 3.34747 8.94097 2.97098 8.54167L3.70759 7.73438C4.42783 8.49826 5.2872 8.88021 6.28571 8.88021C7.3006 8.88021 8.16815 8.50694 8.88839 7.76042C9.60863 6.99653 9.96875 6.07639 9.96875 5C9.96875 3.92361 9.60863 3.01215 8.88839 2.26562C8.16815 1.50174 7.3006 1.11979 6.28571 1.11979C5.27083 1.11979 4.40327 1.50174 3.68304 2.26562C2.97917 3.01215 2.62723 3.92361 2.62723 5H4.19866L2.08705 7.23958L2.03795 7.16146L0 5H1.57143C1.57143 3.61111 2.02976 2.43056 2.94643 1.45833Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLatestProgrammes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/latestProgrammes.cd466e93.svg";
export { ForwardRef as ReactComponent };